import hydrate from '../common/hydrate';
import SeoSection from './components/SeoSection';
import { root, name } from './manifest.json';
hydrate(SeoSection, root, name);
if (module.hot) {
    module.hot.accept();
}
